module.exports = __webpack_public_path__ + "static/img/pico52.72fc953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico52.png
// module id = +S7j
// module chunks = 0